import { render } from "./CategoryPerformance.vue?vue&type=template&id=049d5b85&scoped=true"
import script from "./CategoryPerformance.vue?vue&type=script&lang=js"
export * from "./CategoryPerformance.vue?vue&type=script&lang=js"

import "./CategoryPerformance.vue?vue&type=style&index=0&id=049d5b85&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049d5b85"]])

export default __exports__